module.exports = __webpack_public_path__ + "static/media/retirement-object-3-2-0.8f045ebe.png";